import { TextInputComposition } from '@codeleap/common'
import { variantProvider } from '../theme'

const createTextInputStyle =
  variantProvider.createVariantFactory<TextInputComposition>()
const defaultStyles = variantProvider.getDefaultVariants('TextInput')

const defaultVariant = createTextInputStyle((theme) => ({
  ...defaultStyles.default(theme),
  wrapper: {
    ...defaultStyles.default(theme).wrapper,
  },
  textField: {
    ...defaultStyles.default(theme).textField,
    color: theme.colors.black700,
  },
  error: {
    ...defaultStyles.default(theme).error,
    color: 'red',
  },
  innerWrapper: {
    ...defaultStyles.default(theme).innerWrapper,
    borderRadius: theme.borderRadius.medium,
    borderColor: theme.colors.black200,
    height: 54,
  },
  icon: {
    ...defaultStyles.default(theme).icon,
    color: theme.colors.neutral,
  },
  label: {
    ...defaultStyles.default(theme).label,
    color: theme.colors.black,
    marginBottom: theme.spacing.value(2),
    fontWeight: 'bold',
  },
}))

const MULTILINE_TEXTINPUT = 120

export const AppTextInputStyles = {
  ...defaultStyles,
  default: defaultVariant,
  multiline: createTextInputStyle((theme) => ({
    ...defaultStyles.default(theme),
    innerWrapper: {
      ...defaultStyles.default(theme).innerWrapper,
      minHeight: MULTILINE_TEXTINPUT,
      height: 'auto',
      alignItems: 'start',
      padding: theme.spacing.value(2),
      overflow: 'hidden',
    },
    label: {
      ...defaultStyles.default(theme).label,
      color: theme.colors.black,
      marginBottom: theme.spacing.value(2),
      fontWeight: 'bold',
    },
    textField: {
      ...defaultStyles.default(theme).textField,
      minHeight: MULTILINE_TEXTINPUT - theme.spacing.value(4),
      height: 'auto',
      color: theme.colors.black700,
      resize: 'vertical',
    },
  })),
  'resize:none': createTextInputStyle((theme) => ({
    ...defaultStyles.default(theme),
    textField: {
      ...defaultStyles.default(theme).textField,
      resize: 'none',
      color: theme.colors.black700,
    },
  })),
  contact: createTextInputStyle((theme) => ({
    ...defaultStyles.default(theme),
    wrapper: {
      ...defaultStyles.default(theme).wrapper,
    },
    label: {
      ...defaultStyles.default(theme).label,
      color: theme.colors.primarySolid50,
      marginBottom: theme.spacing.value(2),
      fontWeight: 'bold',
    },
    innerWrapper: {
      ...defaultStyles.default(theme).innerWrapper,
      borderRadius: theme.borderRadius.medium,
      backgroundColor: theme.colors.primarySolid50,
      borderColor: theme.colors.white,
      height: 54,
    },
    textField: {
      ...defaultStyles.default(theme).textField,
      color: theme.colors.neutralBlack300,
      backgroundColor: theme.colors.primarySolid50,
      '&::placeholder': {
        color: theme.colors.neutralBlack300,
      },
    },
  })),
  'contact:multiline': createTextInputStyle((theme) => ({
    ...defaultStyles.default(theme),
    label: {
      ...defaultStyles.default(theme).label,
      color: theme.colors.primarySolid50,
      marginBottom: theme.spacing.value(2),
      fontWeight: 'bold',
    },
    innerWrapper: {
      ...defaultStyles.default(theme).innerWrapper,
      minHeight: MULTILINE_TEXTINPUT,
      height: 'auto',
      alignItems: 'start',
      padding: theme.spacing.value(2),
      overflow: 'hidden',
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
    },
    textField: {
      ...defaultStyles.default(theme).textField,
      minHeight: MULTILINE_TEXTINPUT - theme.spacing.value(4),
      height: 'auto',
      color: theme.colors.neutralBlack300,
      resize: 'none',
      backgroundColor: theme.colors.white,
      '&::placeholder': {
        color: theme.colors.neutralBlack300,
      },
    },
  })),
}
